module.exports = __webpack_public_path__ + "e10bfe2d76c98a58f64367c3f19ab5e3.ttf"


/*****************
 ** WEBPACK FOOTER
 ** ./fonts/MyriadPro-Regular.ttf
 ** module id = 19
 ** module chunks = 0
 **/